import { render, staticRenderFns } from "./chalList.vue?vue&type=template&id=3e55aa09&scoped=true"
import script from "./chalList.vue?vue&type=script&lang=js"
export * from "./chalList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/chat_css/chatList.css?vue&type=style&index=0&id=3e55aa09&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e55aa09",
  null
  
)

export default component.exports